/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import DOMPurify from "dompurify";

import { UseLangContext } from "../../contexts/Lang";
import { CategoryProduct } from "../../@types/lang";
import ModalImage from "../../components/shared/ModalImage";

type Props = {};

const Product = (props: Props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const { id } = useParams();
  const {
    lang,
    getExistProduct,
    t: { categoryProducts, global },
  } = UseLangContext();
  const [product, setProduct] = useState<any>({});

  useEffect(() => {
    const productExist = getExistProduct(id);
    document.title = `Omega Solusindo Bersama | ${productExist.title}`;
    setProduct(productExist);
  }, [lang, id]);

  return (
    <div className="flex flex-col gap-10 py-10">
      {/* Navigation */}
      <div className="inline-flex items-center w-full gap-4 md:gap-0 justify-center px-6 lg:px-20">
        <div className="flex space-x-4 items-center justify-center">
          <Link to="/" className="text-[#A0A0A0]">
            Home
          </Link>
          <span>&gt;</span>
          <div className="flex space-x-2 items-center text-[14px] lg:text-[16px]">
            <p className="text-[#A0A0A0]">Product</p>
            <p className="text-[#A0A0A0]">/</p>
            <p className="font-semibold border-b border-solid border-black">
              {product.name}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-4 md:mt-10 text-center flex flex-col gap-8 px-6 lg:px-20 ">
        <p className="text-[30px] font-semibold text-[#3B3B3B]">
          {global.titleInProductDetail}
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 justify-center items-center">
          <div className="bg-[#81B465] h-1 w-full hidden lg:block order-first"></div>
          {categoryProducts?.map((category: CategoryProduct, index: number) => (
            <Link
              key={index}
              to={`/product/${category.name.toLowerCase().replace(/\s+/g, "-")}`}
              className={`border border-solid border-[#A0A0A0] p-3 flex gap-2 items-center rounded-lg w-full cursor-pointer hover:bg-[#504E48] group transition-all duration-300 ease-in-out ${category.id === product.id ? "bg-[#504E48] pointer-events-none" : "bg-white"}`}
            >
              <div className="group-hover:bg-white rounded-full">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="40" height="40" rx="20" fill="white" />
                  <path
                    d="M23.3107 6.6247L30.6761 10.8771C32.4165 11.8819 33.4886 13.7389 33.4886 15.7485V24.2533C33.4886 26.2629 32.4165 28.1199 30.6761 29.1247L23.3107 33.3771C21.5703 34.3819 19.4261 34.3819 17.6857 33.3771L10.3203 29.1247C8.57993 28.1199 7.50781 26.2629 7.50781 24.2533V15.7485C7.50781 13.7389 8.57993 11.8819 10.3203 10.8771L17.6857 6.6247C19.4261 5.61989 21.5703 5.61989 23.3107 6.6247ZM18.819 8.14306L18.6232 8.2485L11.2578 12.5009C10.1586 13.1355 9.45928 14.28 9.38871 15.5379L9.38281 15.7485V24.2533C9.38281 25.5225 10.0243 26.7004 11.0784 27.3905L11.2578 27.5009L18.6232 31.7533C19.719 32.386 21.0549 32.4211 22.1774 31.8588L22.3732 31.7533L29.7386 27.5009C30.8378 26.8663 31.5371 25.7218 31.6077 24.4639L31.6136 24.2533V15.7485C31.6136 14.4793 30.9721 13.3014 29.918 12.6113L29.7386 12.5009L22.3732 8.2485C21.2774 7.61584 19.9414 7.58069 18.819 8.14306ZM27.0797 15.8359C27.3228 16.2931 27.1493 16.8608 26.6921 17.1038L21.4249 19.904L21.4249 26.2499C21.4249 26.7676 21.0052 27.1874 20.4874 27.1874C19.9697 27.1874 19.5499 26.7676 19.5499 26.2499L19.5499 19.904L14.2828 17.1038C13.8256 16.8608 13.6521 16.2931 13.8951 15.8359C14.1382 15.3788 14.7059 15.2052 15.163 15.4483L20.4874 18.2784L25.8118 15.4483C26.269 15.2052 26.8367 15.3788 27.0797 15.8359Z"
                    fill="#81B465"
                  />
                </svg>
              </div>
              <p
                className={`text-[18px] font-medium group-hover:text-white ${category.id === product.id ? "text-white" : "text-[#3B3B3B]"}`}
              >
                {category.name}
              </p>
            </Link>
          ))}
          <div className="bg-[#81B465] h-1 w-full hidden lg:block order-last"></div>
        </div>
      </div>

      <div className="bg-[#F9F9F9] py-4 md:rounded-tr-[100px] md:rounded-br-[100px] flex items-center gap-4 uppercase font-semibold text-lg md:text-xl lg:text-[30px] w-full md:w-max px-6 md:px-20 justify-center">
        <p className="text-[#81B465]">{product.name}</p>
        <p className="text-black">-</p>
        <p className="text-black">{product.vendorName}</p>
      </div>

      {/* DESCRIPTION */}
      <div className="px-6 lg:px-20">
        <p
          className="text-sm md:text-[16px] text-justify font-normal leading-[35px] text-[#444]"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(product.description),
          }}
        ></p>
      </div>

      {/* Product Image */}
      <div className="flex flex-col gap-4 px-6 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {product.images?.map((image, index) => (
            <button
              className="border border-solid border-[#A0A0A0] p-4 flex flex-col gap-6 items-center rounded-lg cursor-pointer"
              key={index}
              onClick={() => {
                setModalOpen(true);
                setCurrentImage(image);
              }}
            >
              <img
                src={image.url}
                alt={`Product ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <p className="text-[20px] font-medium text-[#3B3B3B]">
                {image.name}
              </p>
            </button>
          ))}
          {modalOpen && (
            <ModalImage
              setModalOpen={setModalOpen}
              setCurrentImage={setCurrentImage}
              images={product.images}
              currentImage={currentImage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Product;
